import { Box, Button, IconButton, Modal, Stack, Typography } from "@mui/material";
import { stringConstant } from "../../utils/string-utils";
import { useLocation, useNavigate } from "react-router-dom";
// import '../../app/css/additional-styles/header.css'
import { CloseOutlined } from "@mui/icons-material";
import { useState } from "react";
import MobileMenu from "./mobile-menu";

export default function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const [logoutModal, setLogoutModal] = useState(false)
  const handleSigninClick = () => {
    navigate('/login');
  };
  const handleLogoutClick = () => {
    localStorage.setItem('clinic', '')
    setLogoutModal(false)
    navigate('/');

  };
  const showSigninButton = location.pathname === '/';
  const ShowLogoutButton = location.pathname === '/home'
  return (<>
    <header className="absolute w-full z-30 ">
      <div className="w-full mx-auto px-4  sm:px-6">
        <div className="flex items-center justify-between h-20">
          <div className="shrink-0 mr-4">
            <img className="max-w-full mx-auto md:max-w-none h-auto" src={'./images/cocLogo.png'} width={100} height={100} alt="Features 01" onClick={() => { if (showSigninButton) { navigate('/') } }} />
          </div>

          {/* Desktop navigation */}
          {ShowLogoutButton && <nav className="hidden md:flex md:grow">
            <ul className="flex grow justify-end flex-wrap items-center">

              <li>
                <button className="btn-sm text-white bg-purple-600 hover:bg-purple-700 ml-3" onClick={() => { setLogoutModal(true) }}>
                  Sign out
                </button>
              </li>
            </ul>
          </nav>}

          {ShowLogoutButton && <MobileMenu callback={(value) => {
            if (value) {
              setLogoutModal(true)
            }
          }} />}

        </div>
      </div>
    </header>


    <Modal open={logoutModal} onClose={() => { setLogoutModal(false) }} sx={{
      justifyContent: 'center', alignItems: 'center', display: 'flex'
    }}>
      {/* <StackmarginTop={-10}> */}
      <Stack bgcolor={'white'} alignItems={'center'} borderRadius={2} >
        <IconButton sx={{ alignSelf: 'end', color: 'red' }} onClick={() => { setLogoutModal(false) }} ><CloseOutlined /></IconButton>
        <div className="max-w-3xl mx-auto text-center pl-6 pr-6 pb-2">
          <p className="text-md text-black mb-8" data-aos="fade-up" data-aos-delay="200">Are you sure want to signout ?</p>
          <button className="btn-sm text-white bg-purple-600 hover:bg-purple-700 ml-3" onClick={handleLogoutClick}>
            Confirm
          </button>
        </div>



        {/* </Stack> */}
      </Stack>
    </Modal >
  </>
  );
}
